import { useSelector } from "react-redux";

import { getNextIdSelector } from "@skilitics/nautilus-core-designer-data";

export const useGetNextId = () => useSelector(getNextIdSelector);
